module.exports = __webpack_public_path__ + "img/light-profile.a056ea9c.svg";